import type { AutomaticAccessorial } from '@api/useFreight/types'
import { useApi } from '@gravitate-js/the-armory'
import { useMutation } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'
import { type BaseScheduleButtonProps, ScheduleRateButton } from './BaseScheduleRateButton'

// Props for Automatic Accessorial Schedule Button
export interface AutomaticAccessorialScheduleButtonProps extends BaseScheduleButtonProps {
  accessorial: AutomaticAccessorial
}

// Automatic Accessorial Schedule Button
export function AutomaticAccessorialScheduleButton(props: AutomaticAccessorialScheduleButtonProps) {
  const api = useApi({ baseURLOverride: getAPIURL() })

  // Custom mutation for creating rates
  const createRateMutation = useMutation({
    mutationFn: (data: {
      accessorial_id: string
      effective_from_date: string
      effective_to_date?: string
      rate: number
    }) => {
      return api.post('freight/accessorial/automatic/rate/create', {
        accessorial_id: data.accessorial_id,
        effective_from_date: data.effective_from_date,
        effective_to_date: data.effective_to_date,
        rate: data.rate,
      })
    },
  })

  const createRate = async (data: {
    accessorial_id: string
    effective_from_date: string
    effective_to_date?: string
    rate: number
  }): Promise<void> => {
    await createRateMutation.mutateAsync({
      accessorial_id: data.accessorial_id,
      effective_from_date: data.effective_from_date,
      effective_to_date: data.effective_to_date,
      rate: data.rate,
    })
  }

  return (
    <ScheduleRateButton
      {...props}
      createRate={createRate}
      invalidateQueryKey={['automaticAccessorials']}
      isLoading={createRateMutation.isPending}
    />
  )
}
